import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { timer } from 'rxjs';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss']
})
export class IconButtonComponent implements OnChanges {
  @Input() buttonId = '';
  @Input() icon = 'close';
  @Input() iconColor = 'inherit';
  @Input() backgroundColor = 'white';
  @Input() isOutline = false;
  @Input() label = '';
  @Input() disabled = false;
  @Input() focus = false;
  @Input() isCdkFocusInitial = false;
  @Input() isSmall = false;
  @Output() action: EventEmitter<MouseEvent | TouchEvent | KeyboardEvent> = new EventEmitter<
    MouseEvent | TouchEvent | KeyboardEvent
  >();

  softFocusDelay = 250;

  @ViewChild('genericIconButton', { static: false }) genericIconButton!: MatButton;

  ngOnChanges({ focus }: SimpleChanges): void {
    if (!!focus && focus.currentValue) {
      this.focusManual();
    }
  }

  /** Forces the focus to be drawn to the button */
  focusManual(): void {
    timer(this.softFocusDelay).subscribe(() => {
      this.genericIconButton.focus();
    });
  }

  /** Blurs the button - removes focus. */
  blurFocus(): void {
    this.genericIconButton._elementRef.nativeElement.blur();
  }
}
